import { yup } from '@framework/validation/initYup.ts';
import { type AlboConfigurazioneTipoCampoDTO } from '../configuration/api/schemas/alboConfigurazioneTipoCampoDTO.ts';
import { EnumAlboConfigurazioneTipoCampoDTOTipo } from '../configuration/api/schemas/enumAlboConfigurazioneTipoCampoDTOTipo.ts';

export function applyRecordTypesFieldValidators(
  campo: AlboConfigurazioneTipoCampoDTO,
  schema: Record<string, yup.AnySchema>,
): void {
  switch (campo.tipo) {
    case EnumAlboConfigurazioneTipoCampoDTOTipo.NUMBER:
      schema[`${campo.codice}Da`] = yup.number().notRequired().nullable();
      schema[`${campo.codice}A`] = yup.number().notRequired().nullable();
      break;
    case EnumAlboConfigurazioneTipoCampoDTOTipo.DATE:
      schema[campo.codice!] = yup.string().notRequired().nullable();
      break;
    default:
      // Per TEXT, SELECT, etc.
      schema[campo.codice!] = yup.string().notRequired().nullable();
      break;
  }
}
